import browser from 'plyr/src/js/utils/browser';
import is from 'plyr/src/js/utils/is';
import { toggleClass } from 'plyr/src/js/utils/elements'

export default class Fullscreen {
  static scrollPosition = { x: 0, y: 0 };
  static toggle(toggle = false, el) {
    if (toggle) {
      this.scrollPosition = {
        x: window.scrollX || 0,
        y: window.scrollY || 0,
      };
    } else {
      window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
    }

    // Toggle scroll
    document.body.style.overflow = toggle ? 'hidden' : '';

    toggleClass(el, "searchie--fullscreen-fallback", toggle);

    let viewport = document.head.querySelector('meta[name="viewport"]');
    const property = 'viewport-fit=cover';

    // Inject the viewport meta if required
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.setAttribute('name', 'viewport');
    }

    // Check if the property already exists
    const hasProperty = is.string(viewport.content) && viewport.content.includes(property);

    if (toggle) {
      this.cleanupViewport = !hasProperty;

      if (!hasProperty) {
        viewport.content += `,${property}`;
      }
    } else if (this.cleanupViewport) {
      viewport.content = viewport.content
        .split(',')
        .filter(part => part.trim() !== property)
        .join(',');
    }
  }
  static enter(frame) {
    if (!browser.isIos) return;
    Fullscreen.toggle(true, frame);
  }
  static exit(frame) {
    if (!browser.isIos) return;
    Fullscreen.toggle(false, frame);
  }
  static setup() {
    if (!browser.isIos) return;
    let style = document.createElement('style');
    style.appendChild(document.createTextNode(`
      .searchie--fullscreen-fallback {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        max-width: 100vw !important;
        max-height: 100vh !important;
        max-height: 100dvh !important;
        min-width: 100vw !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        border-radius: 0 !important;
        background: #000 !important;
        z-index: 2147483647 !important;
        transform: none !important;
        box-sizing: border-box !important;
      }

      /* Auto-hide scrollbars when fullscreen is active */
      html:has(.searchie--fullscreen-fallback),
      body:has(.searchie--fullscreen-fallback) {
        overflow: hidden !important;
      }

      /* Auto-hide scrollbars when fullscreen is active */
      div:has(.searchie--fullscreen-fallback),
      section:has(.searchie--fullscreen-fallback),
      article:has(.searchie--fullscreen-fallback),
      nav:has(.searchie--fullscreen-fallback),
      main:has(.searchie--fullscreen-fallback),
      p:has(.searchie--fullscreen-fallback),
      span:has(.searchie--fullscreen-fallback),
      a:has(.searchie--fullscreen-fallback),
      label:has(.searchie--fullscreen-fallback) {
        transform: none !important;
        filter: none !important;
        perspective: none !important;
        clip-path: none !important;
        mask: none !important;
        mask-image: none !important;
        mix-blend-mode: normal !important;
        isolation: auto !important;
        will-change: auto !important;
        contain: none !important;
        opacity: 1 !important;
        z-index: auto !important;
        position: unset !important;
      }
    `));
    document.head.appendChild(style);
  }
}
